module.exports = __webpack_public_path__ + "static/media/pasticceria_2.8084846d.jpg";